import axios from "axios";
import qs from "qs";
import STUDY_DATA_TEMPLATE from "@/components/study/editor/config/etude_data_template.js";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

async function new_get_qlik_data ({codeInsee, segmentId, etudeTypeId, projectLat, projectLon}) {
	const stats = await axios.get(`${API_BASE_URL}api/commune/GetQlikData/${codeInsee}`, {
		params: {
			segment: segmentId,
			etudeType: etudeTypeId,
			lat: projectLat,
			lon: projectLon
		}
	});
	return stats.data.content.entity;
}

function setup_study_data (project_values, study_values = false) {
	const study_data = _.cloneDeep(STUDY_DATA_TEMPLATE);
	// set title and subtitle
	let titre = project_values.adresse.adresse.split(/\d{5}/)[0].trim();
	if (_.isUndefined(titre) || titre.length === 0) {
		titre = project_values.adresse.adresse;
	}
	study_data.titre = titre;
	study_data.sous_titre = `${project_values.adresse.ville} (${project_values.adresse.codeInsee})`;
	study_data.scpi.garde.designation_adresse = `${project_values.adresse.ville} (${project_values.adresse.codePostal}) ${titre}`;

	if(study_values && study_values.etudeData){
		study_data.code_evalis_status = study_values.etudeData.code_evalis_status;
		study_data.code_evalis_icon = study_values.etudeData.code_evalis_icon;
	}

	return study_data;
}

function sync_study_data (current_study_data) {
	_.forOwn(STUDY_DATA_TEMPLATE, (value, prop) => {
		if (_.isUndefined(current_study_data[prop])) {
			// console.log(prop, 'is undefined, will copy its default value:', STUDY_DATA_TEMPLATE[prop]);
			current_study_data[prop] = _.cloneDeep(STUDY_DATA_TEMPLATE[prop]);
		}
	});
	return current_study_data;
}

function ext_to_icon (ext) {
	// console.log('ext', ext);
	let result = "pdf";
	switch (ext) {
	case "jpg":
	case "png":
		result = "img";
		break;
	case "docx":
		result = "doc";
		break;
	case "xlsx":
	case "xls":
		result = "xls";
		break;
	default:
		result = "pdf";
		break;
	}
	// console.log('icon file will be', result);
	return result;
}

async function get_kyaneos_token () {
	return await axios.get(`${process.env.VUE_APP_API_BASE_URL}api/kyaneos/api/login`)
		.then((response) => {
			return response.data.content;
		})
		.catch((error) => {
			console.log(error);
		});
}

async function get_kyaneos_all_immeubles_data () {
	const token = await get_kyaneos_token();

	const immeublesData = await axios.get(`${process.env.VUE_APP_API_BASE_URL}api/kyaneos/api/immeubles`, {
		headers: { "Token-Kyaneos": `${token}` }
	});

	return immeublesData.data.content;
}
async function get_city_id (codeInsee){
	const city = await axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/cities`, {
		params: {
			"inseeCodes": codeInsee
		}
	});
	return city.data.content.hits[0].id;
}
async function get_kyaneos_scpi_data ( {id} ) {
	const token = await get_kyaneos_token();

	const enumsData = await axios.get(`${process.env.VUE_APP_API_BASE_URL}api/kyaneos/api/enums`, {
		headers: { "Token-Kyaneos": `${token}` }
	});

	const immeubleData = await axios.get(`${process.env.VUE_APP_API_BASE_URL}api/kyaneos/api/immeubles/${id}`, {
		headers: { "Token-Kyaneos": `${token}` }
	});

	immeubleData.data.content.Lots = immeubleData.data.content.Lots.map(lot => ({
		...lot,
		EtatLocatif: enumsData.data.content.EtatsLocatifs[lot.EtatLocatif],
		TypeBail: enumsData.data.content.TypesBail[lot.TypeBail]
	}));

	return immeubleData.data.content;
}

async function get_yanport_scpi_data ( { codeInsee = "", forceVille, searchedData, typeBiens = "APARTMENT", periodeAnalyse = "1" } ) {
	try {
		periodeAnalyse = parseInt(+periodeAnalyse || 1);
		let codeVille;
		if(forceVille.length === 0){
			codeVille = await get_city_id(codeInsee);
		}else{
			codeVille = [];
			for(const element of forceVille){
				codeVille.push(element.id);
			}
		}
		let tableauLocatifRequests = [];
	
		const roomCounts = [undefined, 1, 2, 3, 4, [5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]];

		const d = new Date();
		const requestList = [];
		if(searchedData.includes("tableauLocatif")){
			// TABLEAU LOCATIF
			roomCounts.forEach((roomCount) => {
				tableauLocatifRequests = [...tableauLocatifRequests,
					axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
						params: {
							"size": "20",
							"existingFields": "marketing.priceM2HC",
							"propertyTypes": typeBiens,
							"active": "false",
							"excludeLeBonCoinWith60DurationDays": "true",
							"from": "0",
							"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
							"cityIds": codeVille,
							"marketingTypes": "RENT",
							"percentiles": "50.0",
							"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
							"reliability": "true",
							"field": "PRICE_M2_HC",
							"source": "AD",
							"sort": "marketing.publicationStartDate:desc",
							"roomCounts": roomCount
						},
						paramsSerializer: params => {
							return qs.stringify(params, { indices: false });
						}
					}),
					axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
						params: {
							"size": "20",
							"existingFields": "marketing.publicationDays",
							"propertyTypes": typeBiens,
							"active": "false",
							"excludeLeBonCoinWith60DurationDays": "true",
							"from": "0",
							"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
							"cityIds": codeVille,
							"marketingTypes": "RENT",
							"percentiles": "50.0",
							"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
							"reliability": "true",
							"field": "DURATION_DAYS",
							"source": "AD",
							"sort": "marketing.publicationStartDate:desc",
							"roomCounts": roomCount
						},
						paramsSerializer: params => {
							return qs.stringify(params, { indices: false });
						}
					}),
					axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
						params: {
							"size": "20",
							"existingFields": "features.geometry.roomCount",
							"propertyTypes": typeBiens,
							"active": "false",
							"excludeLeBonCoinWith60DurationDays": "true",
							"from": "0",
							"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
							"cityIds": codeVille,
							"marketingTypes": "RENT",
							"percentiles": "50.0",
							"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
							"field": "SURFACE",
							"source": "AD",
							"sort": "marketing.publicationStartDate:desc",
							"roomCounts": roomCount
						},
						paramsSerializer: params => {
							return qs.stringify(params, { indices: false });
						}
					}),
				];
			});

			const allTableauLocatifRequests = axios.all(tableauLocatifRequests).then((res) => {
				const obj = {};
		
				roomCounts.forEach((roomCount, index) => {
					if(Array.isArray(roomCount)){
						roomCount = roomCount[0];
					}
					obj[roomCount] = {};
					obj[roomCount].prixm2 = res[index * 3].data.content;
					obj[roomCount].dureePublication = res[index * 3 + 1].data.content;
					obj[roomCount].surfaceMediane = res[index * 3 + 2].data.content;
				});
		
				return obj;
			});
			requestList.push(allTableauLocatifRequests);
		}
		if(searchedData.includes("kpiLocatif")){
			// KPI LOCATIF
			const kpiLocatifRequests = [
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
					params: {
						"size": "20",
						"existingFields": "marketing.priceM2HC",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"from": "0",
						"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"cityIds": codeVille,
						"marketingTypes": "RENT",
						"percentiles": "50.0",
						"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
						"reliability": "true",
						"field": "PRICE_M2_HC",
						"source": "AD",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
					params: {
						"size": "20",
						"existingFields": "marketing.publicationDays",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"from": "0",
						"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"cityIds": codeVille,
						"marketingTypes": "RENT",
						"percentiles": "50.0",
						"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
						"reliability": "true",
						"field": "DURATION_DAYS",
						"source": "AD",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/count`, {
					params: {
						"size": "20",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"from": "0",
						"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"cityIds": codeVille,
						"marketingTypes": "RENT",
						"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
						"source": "AD",
						"reliability": "true",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
			];
			const allkpiLocatifRequests = axios.all(kpiLocatifRequests).then((res) => {
				const obj = {
					prixm2: res[0].data.content,
					dureePublication: res[1].data.content,
					biensPublies: res[2].data.content
				};
		
				return obj;
			});
			requestList.push(allkpiLocatifRequests);
		}
		if(searchedData.includes("kpiAncien")){
			// KPI ANCIEN
			const kpiAncienRequests = [
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
					params: {
						"cityIds": codeVille,
						"size": "20",
						"existingFields": "marketing.priceM2",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"from": "0",
						"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"newBuild": "false",
						"marketingTypes": "SALE",
						"percentiles": "50.0",
						"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
						"reliability": "true",
						"field": "PRICE_M2",
						"source": "AD",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
					params: {
						"cityIds": codeVille,
						"size": "20",
						"existingFields": "investment.rental.yield.gross",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"publicationDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"from": "0",
						"newBuild": "false",
						"marketingTypes": "SALE",
						"percentiles": "50.0",
						"publicationDateMin": "2020-07-07T00:00:00.000Z",
						"reliability": "true",
						"field": "GROSS_RENTAL_YIELD",
						"source": "AD",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
					params: {
						"cityIds": codeVille,
						"size": "20",
						"existingFields": "marketing.publicationDays",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"from": "0",
						"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"newBuild": "false",
						"marketingTypes": "SALE",
						"percentiles": "50.0",
						"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
						"reliability": "true",
						"field": "DURATION_DAYS",
						"source": "AD",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/count`, {
					params: {
						"cityIds": codeVille,
						"size": "20",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"from": "0",
						"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"newBuild": "false",
						"marketingTypes": "SALE",
						"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
						"source": "AD",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/properties/percentiles`, {
					params: {
						"cityIds": codeVille,
						"size": "20",
						"existingFields": "marketing.negotiationMargin",
						"propertyTypes": typeBiens,
						"active": "false",
						"excludeLeBonCoinWith60DurationDays": "true",
						"from": "0",
						"deleteDateMax": `${d.toISOString().substring(0, 10)}T00:00:00.000Z`,
						"newBuild": "false",
						"marketingTypes": "SALE",
						"percentiles": "50.0",
						"deleteDateMin": `${(d.getFullYear() - parseInt(periodeAnalyse)) + d.toISOString().substring(4, 10)}T00:00:00.000Z`,
						"reliability": "true",
						"field": "NEGOTIATION_MARGIN",
						"source": "AD",
						"sort": "marketing.publicationStartDate:desc"
					},
					paramsSerializer: params => {
						return qs.stringify(params, { indices: false });
					}
				}),
			];
			const allkpiAncienRequests = axios.all(kpiAncienRequests).then((res) => {
				const obj = {
					prix: res[0].data.content,
					rendementLocatif: res[1].data.content,
					duree: res[2].data.content,
					stock: res[3].data.content,
					margeNegociation: res[4].data.content
				};
		
				return obj;
			});
			requestList.push(allkpiAncienRequests);
		}
		return await axios.all(requestList).then((res) => {
			const obj = {};
			let i = 0;
			for(const label of searchedData){
				obj[label] = res[i];
				i++;
			}
			return obj;
		});
	} catch(e) {
		console.error("Error in fetching Yanport data with codeInsee: ", codeInsee, e);
	}
}

async function get_yanport_villes ( { q = "", lat = 0, lng = 0 } ) {
	const radius = "20000m";
	try {
		const city = await axios.get(`${process.env.VUE_APP_API_BASE_URL}api/yanport/api/cities?lng=${lng}&lat=${lat}&radius=${radius}`, {
			params: {
				q
			}
		});
		return city.data.content.hits;

	} catch (e) {
		console.error("Error in fetching Villes from Yanport data with query: ", q, e);
		return [];
	}
}

export default {
	new_get_qlik_data: new_get_qlik_data,
	setup_study_data: setup_study_data,
	sync_study_data: sync_study_data,
	ext_to_icon: ext_to_icon,
	get_kyaneos_token: get_kyaneos_token,
	get_kyaneos_all_immeubles_data: get_kyaneos_all_immeubles_data,
	get_kyaneos_scpi_data: get_kyaneos_scpi_data,
	get_yanport_scpi_data: get_yanport_scpi_data,
	get_yanport_villes: get_yanport_villes,
	get_city_id: get_city_id
};